const Error = ({ children }) => {
  return <div className="error-message">{children}</div>;
};

export default Error;
